import React from "react";
import styled from "styled-components";
import { colors, sizes } from "@sonder/ui/source/styled/theme";
import { CityMetricsData } from "core/queries/GetBuildingsCityReport";
import { CityMetric } from "reports/components/CityMetric";

const Container = styled.div`
  box-sizing: border-box;
  max-width: ${sizes.listWidth};
  margin: 0 auto;
  padding: 1.5rem 1.714rem 0 1.714rem;
  width: 100%;
`;

const MetricContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 1rem;
`;

const Title = styled.div`
  color: ${colors.gray1};
  font-size: 1.429rem;
  font-weight: bold;
  line-height: 1.429rem;
  margin-inline-end: 6rem;
`;

interface CityMetricsListProps {
  cityMetrics: CityMetricsData[];
}
export const CityMetricsList = ({ cityMetrics }: CityMetricsListProps) => {
  const renderCityMetric = (cityMetric: CityMetricsData, index: number) => {
    const { formattedValue, label, tooltip } = cityMetric;

    return (
      <CityMetric
        formattedValue={formattedValue}
        key={index}
        label={label}
        tooltip={tooltip || undefined}
      />
    );
  };

  return (
    <Container>
      <Title>City metrics</Title>
      <MetricContainer>{cityMetrics.map(renderCityMetric)}</MetricContainer>
    </Container>
  );
};
